import { Description } from '../../../components/Description';
import { Headline } from '../../../components/Headline';
import { Playground } from '../../../components/playground/Playground';
import { Title } from '../../../components/Title';

export const Math = () => (
    <div>
        <Headline anchor='math'>Mathematics</Headline>
        <Description>
            Use native MathML to present mathematical formulas with the browser's semantic formula layout.
        </Description>
        <Playground example={mathExample} />
    </div>
);

const mathExample = (
    <div className='display-grid grid-cols-1 grid-cols-2-sm gap-20'>
        <section className='bg-lightest rounded padding-20'>
            <Title>Mass-energy equivalence</Title>
            <div className='text-center text-size-h3 text-size-20-xs'>
                <math display='block'>
                    <mi>E</mi>
                    <mo>=</mo>
                    <mi>m</mi>
                    <msup>
                        <mi>c</mi>
                        <mn>2</mn>
                    </msup>
                </math>
            </div>
        </section>
        <section className='bg-lightest rounded padding-20'>
            <Title>Fuel consumption</Title>
            <div className='text-center text-size-h4 text-size-20-xs'>
                <math display='block'>
                    <mfrac>
                        <mrow>
                            <mn>42</mn>
                            <mtext>{'\u00a0l'}</mtext>
                        </mrow>
                        <mrow>
                            <mn>560</mn>
                            <mtext>{'\u00a0km'}</mtext>
                        </mrow>
                    </mfrac>
                    <mo>×</mo>
                    <mn>100</mn>
                    <mo>=</mo>
                    <mn>7.5</mn>
                    <mtext>{'\u00a0l/100 km'}</mtext>
                </math>
            </div>
        </section>
    </div>
);
